import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { salesGet, salesPost } from '@/lib/salesTeam';
import { useDashboardIdentity } from '@/hooks/useDashboardIdentity';
import { SalesCard } from './SalesPrimitives';
import styles from './SalesTeam.module.css';

/** Same qrcode, clipboard and native share pattern as FleetDetailPage's join card. */
export function SalesInviteCard() {
  const identity = useDashboardIdentity(), client = useQueryClient();
  const [qr, setQr] = useState(''), [message, setMessage] = useState(''), [busy, setBusy] = useState(false);
  const q = useQuery({ queryKey: ['sales-invite', identity], queryFn: () => salesGet<Array<{ id: string; url: string }>>('admin/sales-flow/codes') });
  const url = q.data?.[0]?.url;
  useEffect(() => {
    let cancelled = false; setQr('');
    if (url) void import('qrcode').then(m => m.default.toDataURL(url, { width: 480, margin: 1 }))
      .then(value => { if (!cancelled) setQr(value); }).catch(() => { if (!cancelled) setMessage('QR code unavailable. You can still copy the link.'); });
    return () => { cancelled = true; };
  }, [url]);
  async function issue(rotate: boolean) {
    setBusy(true); setMessage('');
    try { await salesPost('admin/sales-flow/codes', { rotate }); await client.invalidateQueries({ queryKey: ['sales-invite', identity] }); }
    catch (e) { setMessage(e instanceof Error ? e.message : 'Could not update the link.'); }
    finally { setBusy(false); }
  }
  return <SalesCard title="Your partner invite link">
    <p>Applications record who referred them. EVI approves every partner. An invite never moves an existing partner.</p>
    {q.error && <p role="alert">{q.error.message}</p>}
    {url ? <><label className={styles.field}>Join link<input readOnly value={url} aria-label="Partner join link" /></label>
      {qr && <img src={qr} width={180} height={180} alt="Partner application QR code" />}
      <div className={styles.actions}><button className={styles.secondary} type="button" onClick={() => void navigator.clipboard.writeText(url).then(() => setMessage('Link copied.')).catch(() => setMessage('Select and copy the link above.'))}>Copy link</button>
        <button className={styles.secondary} type="button" onClick={() => { if (navigator.share) void navigator.share({ title: 'EV Initiative partner application', url }).catch(() => undefined); else void navigator.clipboard.writeText(url).then(() => setMessage('Link copied.')).catch(() => setMessage('Select and copy the link above.')); }}>Share</button>
        <button className={styles.secondary} type="button" disabled={busy} onClick={() => { if (window.confirm('Rotate this link? The old link will go to the EVI house book.')) void issue(true); }}>Rotate link</button></div></>
      : <button className={styles.secondary} type="button" disabled={busy || q.isLoading} onClick={() => void issue(false)}>Create invite link</button>}
    {message && <p role="status">{message}</p>}
  </SalesCard>;
}
